import { useEffect, useRef, useState } from 'react'
import { UploadItem } from '@wellesley/uploads'

export const useAwaitedUploadPreviewUrls = (uploads?: UploadItem[]) => {
  const [uploadIdToPreviewUrlMap, setUploadIdToPreviewUrlMap] = useState<
    Record<string, string>
  >({})
  const trackedUploadsRef = useRef<Set<string>>(new Set())

  useEffect(() => {
    if (!uploads?.length) {
      setUploadIdToPreviewUrlMap({})
      trackedUploadsRef.current.clear()
      return
    }

    uploads.forEach((upload) => {
      if (trackedUploadsRef.current.has(upload.id)) return

      trackedUploadsRef.current.add(upload.id)

      upload.upload
        .then((uploadId) => {
          if (uploadId) {
            setUploadIdToPreviewUrlMap((prev) => ({
              ...prev,
              [uploadId]: upload.preview,
            }))
          }
        })
        .catch(() => {
          // Upload failed - ignore
        })
    })

    const currentIds = new Set(uploads.map((u) => u.id))
    trackedUploadsRef.current.forEach((id) => {
      if (!currentIds.has(id)) {
        trackedUploadsRef.current.delete(id)
      }
    })
  }, [uploads])

  return { uploadIdToPreviewUrlMap }
}
